import React from 'react';
import _ from 'lodash';

import {formatDate} from 'utils/datetime';

import Table from 'components/Table';
import Button from 'components/Button';

import checkedCircle from 'assets/icons/circle-check.svg';

import './styles.css';

const RoomScheduleTable = ({roomAllocations, openRoomMoveModal, tenancy}) => (
  <div className="RoomScheduleTable">
    <Table>
      <Table.Header>
        <Table.HeaderItem heading="Room" />
        <Table.HeaderItem heading="Room Type" />
        <Table.HeaderItem heading="Move date" />
        <Table.HeaderItem heading="Move reason" />
        <Table.HeaderItem heading="Move in" />
      </Table.Header>
      <Table.Body>
        {roomAllocations.map(allocation => (
          <Table.Row className="RoomAllocationRow" key={allocation.id}>
            <Table.Cell>{allocation.room.label}</Table.Cell>
            <Table.Cell>{allocation.room.roomType}</Table.Cell>
            <Table.Cell>{formatDate(allocation.startDate)}</Table.Cell>
            <Table.Cell>{allocation.moveReason}</Table.Cell>
            <Table.Cell>
              <img src={checkedCircle} alt="Moved in" />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
    <div className="options">
      <Button blue onClick={openRoomMoveModal} disabled={_.isEmpty(tenancy)}>
        Create room move
      </Button>
    </div>
  </div>
);

export default RoomScheduleTable;
